<template>
  <div>
    {{result}}
  </div>
</template>
<script>
import { get/*, post, put, del*/ } from '@/common/function/http'

export default {
  name: "sampleCors",
  data() {
    return {
      result: '',
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      get('http://avrosoft.synology.me:8888/xwmodel/model/fa4e19fb687643cfb9265687ff116d3e/SHIMAO.xml').then(res => {
        this.result = res
      });
    },
  },
}
</script>